import React, { useCallback } from 'react';
import { getRowColumnCounts } from '@pkgs/components/utils/gridColumns';
import { useMapVisibilityStore } from '@pkgs/components/providers/MapVisibilityStoreProvider';
import { useSearchModuleTracking } from '@pkgs/components/hooks/useSearchModuleTracking';
import { useListings } from '@pkgs/components/hooks/queries/useListings';
import { getSearchListingResultId, type SearchListingResult } from '@ev-tech/search-modules-api';

import { SearchResultCardWrapper } from './SearchResultCardWrapper';

const CARDS_TO_PRELOAD_IMAGES = 5;

export const SearchResultsListData = React.memo(({ gridContainerRef }: { gridContainerRef: React.RefObject<HTMLDivElement | null> }) => {
  const { data: results } = useListings();

  const { trackSearchResultCardClick } = useSearchModuleTracking();
  const isMapActive = useMapVisibilityStore((state) => state.isMapActive);

  const handleCardClick = useCallback(
    (exposeUrl: string, listingResult: SearchListingResult, index: number) => {
      const result = getRowColumnCounts(gridContainerRef, index);
      if (!result) return;
      const { row, column } = result;
      trackSearchResultCardClick({
        exposeUrl,
        listingResult,
        elementId: `property-card_row-${row}_card-${column}`,
        isMapActive,
      });
    },
    [trackSearchResultCardClick, isMapActive, gridContainerRef],
  );

  return results.listings.map((result, cardIndex) => {
    const resultId = getSearchListingResultId(result);

    return (
      <SearchResultCardWrapper
        key={resultId}
        style={{ order: cardIndex }}
        listingResult={result}
        shouldPreloadImage={cardIndex < CARDS_TO_PRELOAD_IMAGES}
        onClick={(exposeUrl) => handleCardClick(exposeUrl, result, cardIndex)}
      />
    );
  });
});

SearchResultsListData.displayName = 'SearchResultsListData';
